import React from 'react';

import { IUnavailability, IUnavailabilityForm } from './types';

type UnavailabilityActionsProps = {
  unavailability?: IUnavailability;
  form: IUnavailabilityForm | null;
  saving: boolean;
  onManage(unavailability: IUnavailability): void;
  onDestroy(unavailability: IUnavailability): void;
  onCancel(): void;
  onSave(): void;
};

const resource = (
  unavailability: IUnavailability | undefined,
  form: IUnavailabilityForm | null,
): IUnavailabilityForm => {
  if (!unavailability) {
    return form!;
  }
  return form && unavailability.id === form.id ? form : unavailability;
};

export const UnavailabilityActions: React.FC<UnavailabilityActionsProps> = ({
  unavailability,
  form,
  saving,
  onManage,
  onDestroy,
  onCancel,
  onSave,
}) => {
  const current = resource(unavailability, form);
  const editing = !!form && (!unavailability || unavailability.id === form.id);

  if (current.id) {
    if (!editing) {
      return (
        <span>
          <button type="button" className="btn btn-default" onClick={() => onManage(unavailability!)} disabled={saving}>
            Edit
          </button>
          <button type="button" className="btn btn-danger" onClick={() => onDestroy(unavailability!)} disabled={saving}>
            Remove
          </button>
        </span>
      );
    }

    return (
      <span>
        <button type="button" className="btn btn-default" onClick={onCancel} disabled={saving}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving}>
          Save
        </button>
      </span>
    );
  }

  return (
    <span>
      <button type="button" className="btn btn-default" onClick={onCancel} disabled={saving}>
        Cancel
      </button>
      <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving}>
        Save
      </button>
    </span>
  );
};

export { resource as unavailabilityResource };
